import { type OptionType, type OtherableOptionType, OtherableOptionTypes } from "@qendo/types";

export function isOtherableOption(type: OptionType): type is OtherableOptionType {
    return OtherableOptionTypes.includes(type as OtherableOptionType);
}
